import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CartProvider } from 'react-use-cart';
import { FoodProvider } from './context/FoodContext';
import { ToastProvider } from './context/ToastContext';


import Navbar from './components/Navbar';
import MobileNavbar from './components/MobileNavbar';
import Footer from './components/Footer';

import './App.css';

const Home = lazy(() => import('./pages/Home'));
const Menu = lazy(() => import('./pages/Menu'));
const ProductDetails = lazy(() => import('./pages/ProductDetails'));
const Cart = lazy(() => import('./pages/Cart'));
const About = lazy(() => import('./pages/About'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  return (
    <ToastProvider>
      <CartProvider>
        <FoodProvider>
          <div className="app-layout">
            <Navbar />
            <MobileNavbar />
            <main className="main-content">
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center min-vh-100">
                  <div className="spinner-border text-accent" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              }>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/menu/:id" element={<ProductDetails />} />
                  <Route path="/cart" element={<Cart />} />


                  <Route path="/about" element={<About />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Suspense>
              <Footer />
            </main>
          </div>
        </FoodProvider>
      </CartProvider>
    </ToastProvider>
  );
}

export default App;
